<template>
	<div class="app-content content" :class="[
      { 'show-overlay': $store.state.app.shallShowOverlay },
      $route.meta.contentClass,
    ]">
		<div class="content-overlay" />
		<div class="header-navbar-shadow" />
		<div class="content-wrapper" :class="contentWidth === 'boxed' ? 'container p-0' : null">
			<slot name="breadcrumb">
				<app-breadcrumb />
			</slot>
			<div class="load" v-if="loading">
				<b-spinner variant="primary" class="spinner" />
			</div>
			<div class="content-body" :class="{ opacity0: loading }">
				<transition :name="routerTransition" mode="out-in">
					<slot />
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
	import router from "@/router";
	import {
		BSpinner
	} from "bootstrap-vue";
	import AppBreadcrumb from "@core/layouts/components/AppBreadcrumb.vue";
	import useAppConfig from "@core/app-config/useAppConfig";

	export default {
		components: {
			AppBreadcrumb,
			BSpinner,
		},
		setup() {
			const {
				routerTransition,
				contentWidth
			} = useAppConfig();
			return {
				routerTransition,
				contentWidth,
				loading: false,
			};
		},
		created() {
			router.beforeEach((to, from, next) => {
				if (to.matched.length == 1) {
					this.loading = true;
				}
				next();
			});
			router.afterEach((to, from) => {
				if (to.matched.length == 1) {
					this.loading = false;
				}
			});
		},
	};
</script>

<style>
	.load {
		margin-top: 1.6rem;
		text-align: center;
	}

	.load .spinner {
		width: 2.5rem;
		height: 2.5rem;
		position: absolute;
	}

	.move-enter {
		transform: translate(0, 6px);
		opacity: 0;
	}

	.move-enter-active {
		transition: all 0.16s;
	}

	.move-enter-to {
		opacity: 1;
	}

	.move-leave {
		opacity: 0;
	}

	.move-leave-active {
		opacity: 0;
		transition: all 0s;
	}

	.move-leave-to {
		opacity: 0;
	}

	.opacity0 {
		opacity: 0 !important;
		display: none !important;
		transition: all 0s;
	}
</style>
